var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"loading-container"},[_c('Loader'),_vm._m(0)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-container"},[_c('h4',{staticClass:"text-center"},[_vm._v(" Please wait while we load your most recent application data. ")])])
}]

export { render, staticRenderFns }